import SearchBar from '@/atoms/SearchBar/SearchBar';
import Carousel from '@/molecules/Carousel/Carousel';
import TemplateRow from '@/molecules/TemplateRow/TemplateRow';
import Avatar from 'react-avatar';

import './Home.scss';

const Home = () => {
	return (
		<div className='home'>
			<div className='searchRow'>
				<SearchBar />
				<Avatar name='aayush dongre' round size='40' />
			</div>
			<Carousel />
			<h2 className='templates'>Templates</h2>
			<TemplateRow
				title='Head Accessories'
				subtitle='Headgears, hair do'
				templateDetails={[
					{
						url: '/static/img/templates/0.png',
					},
					{
						url: '/static/img/templates/1.png',
					},
					{
						url: '/static/img/templates/2.png',
					},
				]}
			/>
			<TemplateRow
				title='Eyewear'
				subtitle='Sunglasses lenses'
				templateDetails={[
					{
						url: '/static/img/templates/3.png',
					},
					{
						url: '/static/img/templates/4.png',
					},
					{
						url: '/static/img/templates/5.png',
					},
				]}
			/>
			<TemplateRow
				title='Beards'
				subtitle='Beards, Moustache'
				templateDetails={[
					{
						url: '/static/img/templates/5.png',
					},
					{
						url: '/static/img/templates/1.png',
					},
					{
						url: '/static/img/templates/3.png',
					},
				]}
			/>
		</div>
	);
};

export default Home;
